import { render } from "./PublicationFollowUpsComponent.vue?vue&type=template&id=0fcd7ed4&scoped=true"
import script from "./PublicationFollowUpsComponent.vue?vue&type=script&lang=js"
export * from "./PublicationFollowUpsComponent.vue?vue&type=script&lang=js"

import "./PublicationFollowUpsComponent.vue?vue&type=style&index=0&id=0fcd7ed4&scoped=true&lang=css"

import exportComponent from "/Users/norberto/Documents/Marketing HL/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcd7ed4"]])

export default __exports__